import { Image } from "../image/image";
import { Text } from "../text/text";

import styles from "./rewards.module.css"

export const RewardCard = ({ icon, title, subtitle }) => {
    return (
        <div className={styles.user_reward_card}>
            <div className={styles.reward_icon}>
                <Image src={icon} width="80px" height="60px" />
            </div>
            <Text as="div" variant="captionStrong" className={styles.reward_title} align="center">
                {title}
            </Text>
            <Text as="div" variant="tiny" className={styles.reward_subtitle} align="center">
                {subtitle}
            </Text>
        </div>
    )
}
